module.exports = __webpack_public_path__ + "6dd936f6d55c52c0699194d5819c8d34.MP3";